var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKalender = function SvgKalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236 236"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 11.55,
    d: "M65.64 56.56h48.51M193.77 122.94v56.9c0 8.2-6.75 14.9-15 14.9H36.74c-8.25 0-15-6.7-15-14.9V71.45c0-8.19 6.75-14.89 15-14.89h4.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 8.09,
    d: "M21 103.77h98.2M78.42 197v-94.14M136.11 197v-77.17M21 133.71h171.48M21 162.07h171.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 10.39,
    d: "M224 76.76c0 29.7-25.51 53.76-56.98 53.76-31.47 0-56.97-24.07-56.97-53.76 0-29.69 25.5-53.76 56.97-53.76S224 47.07 224 76.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M167.08 108.07h-.62a6.76 6.76 0 0 1-6.77-6.72V51.4c0-3.7 3.04-6.72 6.77-6.72h.62a6.76 6.76 0 0 1 6.77 6.72v49.94c0 3.7-3.04 6.72-6.77 6.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M135.4 77.06v-.63c0-3.7 3.05-6.72 6.78-6.72h50.32a6.76 6.76 0 0 1 6.77 6.72v.63c0 3.7-3.05 6.71-6.77 6.71h-50.32a6.76 6.76 0 0 1-6.77-6.71M53.94 74.26h-.68a7.37 7.37 0 0 1-7.38-7.32V44.8a7.37 7.37 0 0 1 7.38-7.32h.68c4.06 0 7.38 3.3 7.38 7.32v22.14a7.37 7.37 0 0 1-7.38 7.32"
  }))));
};
export default SvgKalender;